import { compare } from 'compare-versions';

// Force update minis as requested here: https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/761
export function minisStatisticsForceUpdateCheck(device, settings) {
	// for those lovely cloud disabled devices...
	if (!settings?.DeviceInfo) {
		return false;
	}
	const currentVersion =
		settings?.DeviceInfo.ver.indexOf('-') > -1
			? settings.DeviceInfo.ver.split('-')[0]
			: settings.DeviceInfo.ver;
	return (
		(device.type === 'SNPM-001PCEU16' || device.type === 'SNSW-001P8EU') &&
		compare(currentVersion, '1.0.1', '<')
	);
}
